import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

const MENU_WIDTH = 224; // tw-w-56

const CompanySearchActions = ({ rowData, getSlugHandler, setSelectedRowData, isMirror, handleViewClick, tradeDirection, onTrackViewContacts, onTrackBookmark }) => {
  const [open, setOpen] = useState(false);
  const [menuStyle, setMenuStyle] = useState({});
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  const toggleMenu = () => {
    if (!open && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const estimatedMenuHeight = 120;
      const top = spaceBelow >= estimatedMenuHeight ? rect.bottom + 4 : rect.top - estimatedMenuHeight - 4;
      setMenuStyle({
        position: "fixed",
        top,
        left: rect.right - MENU_WIDTH,
        zIndex: 9999,
      });
    }
    setOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target) && buttonRef.current && !buttonRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const handleScroll = () => setOpen(false);
    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", handleScroll, true);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, []);

  const menuItems = [
    {
      label: (
        <div className="tw-font-medium tw-text-sm tw-text-primary-purple-600 tw-flex tw-items-center tw-gap-1">
          <span className="material-symbols-outlined tw-text-[#1c1b1f]">outbound</span>View {tradeDirection === "import" ? "Imports" : "Exports"} Shipments
        </div>
      ),
      id: "shipments",
      action: () => {
        handleViewClick(rowData);
      },
    },
    {
      label: (
        <div className="tw-font-medium tw-text-sm tw-text-primary-purple-600 tw-flex tw-items-center tw-gap-1">
          <span className="material-symbols-outlined tw-text-[#1c1b1f]">account_circle</span>View Contacts Info
        </div>
      ),
      id: "contacts",
      action: () => {
        onTrackViewContacts?.();
        getSlugHandler(rowData.hashed_id, "&redirectTab=contacts");
      },
    },
    {
      label: (
        <div className="tw-font-medium tw-text-sm tw-text-primary-purple-600 tw-flex tw-items-center tw-gap-1">
          <span className="material-symbols-outlined tw-text-[#1c1b1f]">star</span>Bookmark
        </div>
      ),
      id: "bookmark",
      action: () => {
        onTrackBookmark?.();
        setSelectedRowData([rowData]);
      },
    },
  ];

  return (
    <div className="tw-inline-block">
      <button ref={buttonRef} onClick={toggleMenu} className={`tw-p-2 tw-rounded-lg tw-size-9 tw-bg-primary-purple-600 hover:tw-bg-primary-purple-700 ${open ? "tw-bg-primary-purple-700" : ""}`}>
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff">
          <path d="M480-160q-33 0-56.5-23.5T400-240q0-33 23.5-56.5T480-320q33 0 56.5 23.5T560-240q0 33-23.5 56.5T480-160Zm0-240q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm0-240q-33 0-56.5-23.5T400-720q0-33 23.5-56.5T480-800q33 0 56.5 23.5T560-720q0 33-23.5 56.5T480-640Z" />
        </svg>
      </button>

      {open &&
        createPortal(
          <div ref={menuRef} style={menuStyle} className="tw-w-56 tw-overflow-hidden tw-bg-white tw-rounded-lg tw-shadow-lg tw-border tw-border-gray-200">
            <ul className="tw-list-none tw-divide-y tw-mb-0">
              {menuItems.map((item) => {
                if (item.id === "shipments" && isMirror) {
                  return;
                }
                return (
                  <li
                    key={item.id}
                    className={`tw-px-3 tw-py-2 tw-text-sm ${item.disabled ? "tw-text-gray-400 tw-cursor-not-allowed" : "tw-cursor-pointer hover:tw-bg-gray-50"}`}
                    onClick={() => {
                      if (!item.disabled && item.action) {
                        setOpen(false);
                        item.action();
                      }
                    }}>
                    {item.label}
                  </li>
                );
              })}
            </ul>
          </div>,
          document.body
        )}
    </div>
  );
};

export default CompanySearchActions;
